<template>
  <div>
    <textarea rows="24" v-model="state"></textarea>
    <button @click="saveState">Save</button>
    <p v-if="error">{{ error }}</p>
  </div>
</template>

<script>
import util from "./util/util";

export default {
  name: "State",
  data() {
    return {
      error: "",
    };
  },
  computed: {
    state: {
      get() {
        return JSON.stringify(this.$store.state.character).replace(/\\/g, "");
      },
      set(val) {
        if (util.checkState(val)) {
          this.$store.commit("updateCharacterState", val);
        }
      },
    },
  },
  methods: {
    saveState: function () {
      console.log(this.state);
    },
  },
};
</script>

<style lang="css" scoped>
textarea {
  width: 70%;
  height: 60%;
}
</style>